function generateDefaultInitialCustomerState() {
  return {
    personas: []
  }
}

function customerReducer(state = generateDefaultInitialCustomerState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_CUSTOMER_INFO_FULFILLED': {
      newState = {
        ...state,
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default customerReducer;
export {generateDefaultInitialCustomerState};
